import defaultChart from './PDFBaseChart';
/* eslint-disable no-param-reassign */
const circleSvg = d3.create('svg');
circleSvg.attr('viewBox', '0 0 10 10');
// bulletSvg.style('stroke', '#ff0000');
circleSvg.append('circle')
    .attr('cx', 5)
    .attr('cy', 5)
    .attr('r', 5)
    .attr('fill', '#2E393F');

export default (metric, template) => {
    const { colour } = template;
    const { chart, label } = defaultChart(metric, template);
    if (metric.value) {
        chart.h = 'h-2';
        chart.w = 'w-2';
        // chart.x = 'w-2';
        // chart.position = 'parent';
        // chart.y = 0;
        // label.w = 'w-2';
        template.label = {
            w: 'w-2',
            label,
            val: {
                mt: 6,
                text: `${metric.format(metric.value)}${metric.valueUnits}`,
                font: { weight: 'bold', size: '2xl', colour },
                h: 'h-0-1/2'
            },
            compare: {
                compareText: {
                    w: 'w-1',
                    text: `${metric.formatWithUnits(metric.comparisonValue)} in ${metric.comparisonLabel}`,
                },
                symbol: {
                    display: 'inline',
                    mt: 1,
                    ml: metric.comparisonLabel === 'AB' ? -15 : -5,
                    w: 5,
                    h: 5,
                    svg: circleSvg.node()
                }

            },
            target: metric.target && {
                text: `The target is ${metric.formatWithUnits(metric.target)}`,
                font: { colour },
                y: 'h-0-1/8'
            }
        };
        // template.h = 'h-4-1/2';
        chart.display = 'inline';
        // definition.y = 'h-2-1/16';
        // return {
        //     label,
        //     chart,
        // };
    }
    // console.log('Margin waffle', template);
    return template;
};
